module.exports = __webpack_public_path__ + "img/devz-logo.9b02e410.svg";